var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5254 0.546875H0.5V13.4531H14.5V3.52152L11.5254 0.546875ZM11.1914 12.6328H3.80859V8.61328C3.80859 8.38712 3.99259 8.20312 4.21875 8.20312H10.7812C11.0074 8.20312 11.1914 8.38712 11.1914 8.61328V12.6328ZM11.1914 4.92188H3.80859V1.36719H9.00391V4.10156H9.27734H9.82422H10.0977V1.36719H11.1914V4.92188Z",
    fill: "#F7ECFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/Save.5013b27643b760b61e77cc21f9f88c8b.svg";
export { ForwardRef as ReactComponent };